import { Navigate } from "react-router-dom";
import { useStore } from "../contexts/StoreContext";

// Pages whose every action is owner/admin-only on the API (store settings,
// billing, integrations). A member reaching one by URL is sent to the
// dashboard rather than shown forms that can only fail with a 403.
export default function ManagerOnlyRoute({ children }) {
  const { canManageStore } = useStore();

  if (!canManageStore) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
